module.exports = __webpack_public_path__ + "f14b28bd8581f9855a81f8b2839c4298.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/guess.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/guess.jpg
// module chunks = 40